import { ref, watch } from "vue";

export default (props) => {
    const isTranslate = ref(false);// 是否翻译过

    // 翻译
    function handleTranslate(e) {
        window.translate.setDocuments([document.getElementById("artcle_content"), document.getElementById("article_title")]);
        window.translate.changeLanguage(e);
        isTranslate.value = true;
    }

    // 重置
    function handleTranslateReset() {
        window.translate.reset();
        isTranslate.value = false;
    }

    watch(() => props.article, () => {
        isTranslate.value = false;
        handleTranslateReset();
    })

    return { handleTranslate, handleTranslateReset, isTranslate }
}